import { render } from "./sales.vue?vue&type=template&id=6f84ac46&scoped=true"
import script from "./sales.vue?vue&type=script&lang=js"
export * from "./sales.vue?vue&type=script&lang=js"

import "./sales.vue?vue&type=style&index=0&id=6f84ac46&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f84ac46"]])

export default __exports__